export const NAME_REG = /^[\u4e00-\u9fa5]{2,4}$/
export const ID_CARD_REG = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
export const PHONE_REG = /^1[0-9][0-9]\d{8}$/
export const CODE_REG = /^[0-9]{6}$/
